import React, { useMemo } from "react"
import PropTypes from "prop-types"
import SelectInput from "../../../common/inputs/common/SelectInput"
import i18n from "../../../i18n"
import {WAGERING_TYPE} from "./promotionConstants"


function WageringTypeSelect({ onChange, value, ...props }) {
  const options = useMemo(() => Object.values(WAGERING_TYPE).
    map(item => ({ label: i18n.t(`promotions.constants.${item}`), value: item })),[]);

  return (
    <SelectInput
      {...props}
      onChange={onChange}
      value={value}
      options={options}
    />
  );
}

WageringTypeSelect.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default React.memo(WageringTypeSelect);
